/** tax_1099_vendors.status: 1 = active. Only these can be assigned to an expense. */
const ACTIVE_VENDOR = 1;

export interface VendorOption {
    value: number;
    label: string;
}

export const activeVendorOptions = (vendors: any[] | undefined): VendorOption[] =>
    (vendors || [])
        .filter((vendor: any) => vendor?.id && Number(vendor.status) === ACTIVE_VENDOR && `${vendor.display_name || ''}`.trim())
        .map((vendor: any) => ({ value: Number(vendor.id), label: `${vendor.display_name}`.trim() }))
        .sort((a, b) => a.label.localeCompare(b.label));

/**
 * The vendor a check's payee names, or null.
 *
 * Exact name match, ignoring case and edge whitespace -- the same rule Payee
 * Review marks "high" confidence. Two vendors with one name is ambiguous, so
 * nothing is chosen; a wrong pre-selection posts money to the wrong 1099.
 */
export const matchVendorByPayee = (payeeName: string | null | undefined, options: VendorOption[]): number | null => {
    const key = `${payeeName || ''}`.trim().toLowerCase();
    if (!key) return null;
    const hits = options.filter((option) => option.label.toLowerCase() === key);
    return hits.length === 1 ? hits[0].value : null;
};
